// vendors
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AuthInitialState } from './auth.state';

// 1. Get the whole feature state
export const selectAuthState = createFeatureSelector<AuthInitialState>('auth');

// 2. Individual selectors
export const selectIsAuthenticated = createSelector(
  selectAuthState,
  (state: AuthInitialState) => state.isAuthenticated
);

export const selectAuthUser = createSelector(
  selectAuthState,
  (state: AuthInitialState) => state.user
);

export const selectCompanyDetails = createSelector(
  selectAuthState,
  (state: AuthInitialState) => state.companyDetails
);

export const selectCompanyKioskSettings = createSelector(
  selectAuthState,
  (state: AuthInitialState) => state.kioskSettings
);
